<!--
 RocketSearch App
 devs@droxit.de
 Copyright (c) 2020 droxIT GmbH

 Version: 0.17.0
-->

<template>
  <div id="rocketsearch-app" v-click-outside="clickOutside" class="rocketsearch-app">
    <SearchBar/>
    <ResultContainer/>
  </div>
</template>

<style scoped lang="scss">
  .rocketsearch-app::v-deep {
    @import 'bootstrap/scss/bootstrap.scss';
    @import 'bootstrap-vue/src/index.scss';
  };
</style>

<script>
  import SearchBar from './components/SearchBar.vue'
  import ResultContainer from "./components/ResultContainer"
  import Vue from 'vue'
  import {BootstrapVue, IconsPlugin} from 'bootstrap-vue'
  import "./assets/fontface.css"


  // Install BootstrapVue
  Vue.use(BootstrapVue)
  // Optionally install the BootstrapVue icon components plugin
  Vue.use(IconsPlugin)

  export default {
    name: 'App',
    components: {
      SearchBar,
      ResultContainer
    },
    methods: {
      clickOutside: function () {
        this.$root.$emit('ClickOutsideEvent');
      },
    }
  }
</script>